import React, { useState, useEffect } from 'react';

const Clientes = () => {
  const [index, setIndex] = useState(0);

  // Images from public/imgs starting with clientes-slider-
  const logos = [
    '/imgs/clientes-slider-Adisdas-2.png',
    '/imgs/clientes-slider-alto-parana-2.jpg',
    '/imgs/clientes-slider-Andreani2.jpg',
    '/imgs/clientes-slider-andromaco2.jpg',
    '/imgs/clientes-slider-Bodega-La-rural-1.jpg',
    '/imgs/clientes-slider-Cencosud_logo.svg-1.png',
    '/imgs/clientes-slider-clarin-2.jpg',
    '/imgs/clientes-slider-conarpesa2.jpg',
    '/imgs/clientes-slider-Converse2.svg_.png',
    '/imgs/clientes-slider-correo-2.png',
    '/imgs/clientes-slider-dhl-2.png',
    '/imgs/clientes-slider-dia-2.jpg',
    '/imgs/clientes-slider-diadora-2.jpg',
    '/imgs/clientes-slider-Doina-logo2.png',
    '/imgs/clientes-slider-fila-2.jpg',
    '/imgs/clientes-slider-lg_lecoqsportif2.png',
    '/imgs/clientes-slider-logo-fv2.jpg',
    '/imgs/clientes-slider-Lopez-2.jpg',
    '/imgs/clientes-slider-Pascual-2-1.jpg',
    '/imgs/clientes-slider-Philips2-1.png',
    '/imgs/clientes-slider-Pony2-1.png',
    '/imgs/clientes-slider-PUMA2-1.jpg',
    '/imgs/clientes-slider-Salomon2-1.png',
    '/imgs/clientes-slider-ups2-1.png',
    '/imgs/clientes-slider-vino-rutini-cabernet-malbec.jpg'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % logos.length);
    }, 2500);
    return () => clearInterval(timer);
  }, [logos.length]);

  const prev = () => setIndex((prev) => (prev - 1 + logos.length) % logos.length);
  const next = () => setIndex((prev) => (prev + 1) % logos.length);

  return (
    <section id="clientes" className="section clientes">
      <div className="clientes-container">
        <h2 className="section-title">Nuestros Clientes</h2>
        <p className="section-subtitle">
          Un amplio espectro de empresas con exigentes especificaciones confían en nuestros desarrollos de envases:
        </p>
        <p className="clientes-description">
          Pesqueras, Alimentación, Frigoríficos, Bodegas, Autopartes, Laboratorios, Indumentaria y Calzado, Juguetes, Electrodomésticos, Agroquímicos, etc.
        </p>

        <div className="clientes-slider">
          <button className="clientes-nav clientes-nav-prev" onClick={prev}>‹</button>
          <div className="clientes-viewport">
            <div className="clientes-track" style={{ transform: `translateX(-${index * 180}px)` }}>
              {logos.concat(logos).map((src, i) => (
                <div key={i} className="clientes-item">
                  <img src={src} alt={`Cliente ${i + 1}`} className="clientes-logo-img" />
                </div>
              ))}
            </div>
          </div>
          <button className="clientes-nav clientes-nav-next" onClick={next}>›</button>
        </div>
      </div>
    </section>
  );
};

export default Clientes;
